import styled from 'styled-components';
// import { breakpoints } from 'shared/utils/styles';

export const Wrapper = styled.div`
  /* padding: 0px 32px 50px 0px;
  @media (min-width: 1200px) {
    padding: 0px 20px 50px 0px;
  }
  justify-self: center; */
`;

export const Body = styled.div`
  /* display: grid; */
  /* grid-gap: 20px; */
  /* margin: 0 0 0 23px; */
/* 
  grid-template-areas:
    'header'
    'breadcrumb'
    'content'
    'sidebar'
    'footer';

  @media (min-width: 600px) {
    grid-template-areas:
      'header header'
      'breadcrumb breadcrumb'
      'content sidebar'
      'footer footer';
    grid-template-columns: 70% 30%;
    grid-template-rows: 60px 1fr; */
  }
`;